module.exports = __webpack_public_path__ + "static/Homegroups-841e4596b057d1f07b4f86a98edd1b97.jpg";